/**
 * @generated SignedSource<<b5bd21e51c19e90842deeee06537b9b7>>
 * @relayHash 493f48d395cf6bf7cb782ab8af85346d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e4db32c5a76d2eba3d1a4e7d2a4c1a479e19c03f64c2901956c85da29d6ee6d1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { userLimitSlideProjectKeysTrialAwarenessModalQuery } from './userLimitSlideProjectKeysTrialAwarenessModalQuery.graphql';

const node: PreloadableConcreteRequest<userLimitSlideProjectKeysTrialAwarenessModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e4db32c5a76d2eba3d1a4e7d2a4c1a479e19c03f64c2901956c85da29d6ee6d1",
    "metadata": {},
    "name": "userLimitSlideProjectKeysTrialAwarenessModalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
